import IprojectData from "./projectData.interface"

export enum PhaseType{
    None,
    CALL = "CALL",
    TRANSIT = "TRANSIT",
    STATION = "STATION",
    TRANSECT = "TRANSECT"
}

export default interface Iphase {
    id:number
    project:IprojectData
    alias?: string
    index: number
    type: PhaseType
    vessel?: string
    start_date: string
    end_date: string
}